import { render } from "./EventShow-View.vue?vue&type=template&id=68a44ad0"
import script from "./EventShow-View.vue?vue&type=script&lang=js"
export * from "./EventShow-View.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__